<template>
  <div>
    <div id="aaa"></div>
    <van-nav-bar style="background: #ffffff;color:#323233;font-weight: bold"
      fixed
      title="耗材列表"
      left-arrow
      @click-left="onClickLeft"
    />
    <van-row style="width: 100%;top: 37px;position: fixed;z-index: 10000;width: 100%;">
      <van-col span="24">
        <van-search
          sticky
          v-model="value"
          placeholder="耗材名称/品牌"
          show-action
          shape="round"
          @input="onSearch"
        >
          <div slot="action" @click="onSearch">搜索</div>
        </van-search>
      </van-col>
    </van-row>

    <van-row type="flex" style="margin-top: 39px;">
      <van-col span="6">
        <van-sidebar  style="position: fixed;" v-model="activeKey" @change="onChange">
          <van-sidebar-item v-for="(item,index) in firstCategory" :key="index" :title="item.name" />
        </van-sidebar>
      </van-col>
      <van-col span="18">
        <van-cell-group :border="false">
          <van-cell class="haha">
            <van-cell v-for="(item,index) in modelList" 
              :key="index" 
              @click="selectedItem(item.name,item.manufacturers_uuid,item.uuid,item.unitname,item.price)"
            >
              <van-row class="ha" type="flex">
                <van-col span="24">{{item.name}}</van-col>
              </van-row>
              <van-row type="flex" justify="space-between">
                <van-col span="10">品牌:{{item.brandname}}</van-col>
                <van-col span="10">单位:{{item.unitname}}</van-col>
              </van-row>
            </van-cell>
          </van-cell> 
        </van-cell-group>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import  { NavBar,Search,Sidebar, SidebarItem,Col, Row} from 'vant'
export default {
  components:{
    [NavBar.name]:NavBar,
    [Sidebar.name]:Sidebar,
    [Col.name]:Col,
    [Row.name]:Row,
    [SidebarItem.name]:SidebarItem,
    [Search.name]:Search
  },
  data(){
    return{
      value: '',
      activeKey:0,
      firstCategory:["ALL","胶片","墨盒","针筒"],
      modelList:[],
      defaultFirstcategory:''
    }
  },
  methods: {
    onClickLeft() {
      let path = this.$route.query.from;
      this.$router.push({
        name:path,
      })
    },
    onSearch() {
      //window.console.log(this.value);
      this.getModelList(this.defaultFirstcategory,'',this.value);
    },
    onChange(index) {
      this.defaultFirstcategory = this.firstCategory[index].id;
      this.getModelList(this.defaultFirstcategory,'',this.value);
    },
    parseFirstCategory(category) {
      let newarr = [
        {
          id:'',
          name:"ALL"
        }
      ];
      for(let i=0;i<category.length;i++) {
        newarr.push(category[i]);
      }
      return newarr;
    },
    getModelList(firstCategory,lastCategory,keyword) {
      let _this = this;
      this.$http.post('/admin/modelList',{
        firstCategory,
        lastCategory,
        keyword
      }).then(function (response) {
      
        //window.console.log(response);
        _this.modelList = response.model;
      
      })
    },
    selectedItem(modelname,branduuid,modeluuid,unit,unitcost) {
      let path = this.$route.query.from;
      let index = this.$route.query.index;
      let message = this.$route.query.message;
      this.$router.push({
        name:path,
        params:{
          message,
          index,
          modelname,
          branduuid,
          modeluuid,
          unit,
          unitcost
        }
      })
    }
    
  },
  created() {
    let _this = this;
    this.$http.post('/mobile/firstCategoryList').then(function (response) {
      //window.console.log(response);
      _this.firstCategory = _this.parseFirstCategory(response.category);
      
    })
    this.getModelList(this.defaultFirstcategory,'',this.value);
  }
}
</script>

<style scoped lang="less">
#aaa{
  width:100vw;
  height:46px;
}
.ha {
  border-bottom: 0.2px solid 	#DCDCDC	
}
.van-nav-bar .van-icon {
  color: rgba(0,0,0,.7);
}

</style>